/**
 * PlanStatusPill — the finder's plan-status chip (or "No plan"), one status
 * vocabulary shared by the results table and the wizard. Non-component helpers
 * (latestPlan, the status map, the wizard catalog) live in `planCatalog.ts` so
 * this file stays component-only.
 */
import type { PlanOut } from "@api/types";
import { translate } from "@i18n/messages";
import type { Locale } from "@i18n/locales";
import { STATUS_KEY, statusClass } from "./planCatalog";

/** The plan-status pill for a finder event (or "No plan"). */
export function PlanStatusPill({ plan, locale }: { plan: PlanOut | null; locale: Locale }) {
  if (!plan) {
    return <span className="plan-status none">{translate(locale, "plan.status.none")}</span>;
  }
  return (
    <span className={`plan-status ${statusClass(plan.status)}`}>
      ● {translate(locale, STATUS_KEY[plan.status], { n: plan.version })}
    </span>
  );
}
